import { CastUtility, RequestDataModel } from '@ktvs8/gocoo-engine-front-end';

/**
 * 番組名の検索処理
 * @param requestModel
 * @returns
 */
export function filterProgramBySearchDay(requestModel: RequestDataModel) {
  const day = requestModel.requestData['searchDay'];
  return ProgramTestData.filter((x) => x.OnairDate.includes(day, 0));
}

export function findProgramByTicketKey(requestModel: RequestDataModel) {
  const ticketKey = requestModel.requestData['TicketKey'];
  return ProgramTestData.find((x) => x.TicketKey === ticketKey);
}
export const ProgramTestData = [
  {
    TicketType: 'Program',
    TicketKey: getToday() + '#Today2',
    EventID: 'Today2',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getToday(),
    OnairTime: '12:01:00',
    ProgramName: '魔法の筒',
    PublishTime: getToday() + ' 12:01:00',
    OnairDatetime: getToday() + ' 12:01:00',
    Status: 'OrderNotFinished',
    StatusName: '未発注',
    Active: true,
    Subtickets: {
      ProgramOrder: [
        {
          TableName: 'ProductionDepartmentManager',
          TicketType: 'ProgramOrder',
          TicketKey: 'ProgramOrder-1111-1111-1111',
          LsiKey: null,
          MProgramTicketKey: '',
          OnairDate: getToday(),
          OrderType: 'Master',
          MProgramOrderTicketKey: '',
          Content: 'V123',
          Memo: '黒炎弾',
          ReceiptDate: getDay(-5),
          ReceiptDateType: '',
          CountBeforeOnairdate: '',
          DirectReceiptDate: '',
          StopOrder: '',
          ReceiptDateTicketLink: [getDay(-5) + '#1111-2222-3334'],
          Status: 'OrderNotFinished',
          StatusName: '未発注',
          Active: true,
          Subtickets: {},
          Baseticket: {
            tableName: 'ProductionDepartmentManager',
            ticketType: 'Program',
            ticketKey: getDay(2) + '#AddToday3',
          },
        },
      ],
    },
  },
  {
    TicketType: 'Program',
    TicketKey: getToday() + '#Today3',
    EventID: 'Today3',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getToday(),
    OnairTime: '26:01:00',
    ProgramName: '青い目を持つ究極の竜',
    PublishTime: getToday() + ' 26:01:00',
    OnairDatetime: getToday() + ' 26:01:00',
    Status: 'OrderFinished',
    StatusName: '発注済',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(1) + '#AddToday2',
    EventID: 'AddToday2',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getDay(1),
    OnairTime: '04:00:00',
    ProgramName: '聖なる壁　反射鏡の力',
    PublishTime: getDay(1) + ' 04:00:00',
    OnairDatetime: getDay(1) + ' 04:00:00',
    Status: 'OrderNone',
    StatusName: '発注無',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(2) + '#AddToday3',
    EventID: 'AddToday3',
    MProgramTicketKey: 'test#1111-1111-1112',
    OnairDate: getDay(2),
    OnairTime: '05:00:00',
    ProgramName: '黒い悪魔の竜',
    PublishTime: getDay(2) + ' 05:00:00',
    OnairDatetime: getDay(2) + ' 05:00:00',
    Status: 'OrderFinished',
    StatusName: '発注済',
    Active: true,
    Subtickets: {
      ProgramOrder: [
        {
          TableName: 'ProductionDepartmentManager',
          TicketType: 'ProgramOrder',
          TicketKey: 'ProgramOrder-1111-1111-1112',
          LsiKey: null,
          MProgramTicketKey: 'test#1111-1111-1111',
          OnairDate: getDay(2),
          OrderType: 'Master',
          MProgramOrderTicketKey: 'test#1111-1111-1111#000-0000-0000',
          OrderSheetTicketKey: getDay(2) + '#testData-1111-1111-1111',
          Content: 'V123',
          Memo: '',
          ReceiptDate: '',
          ReceiptDateType: '',
          CountBeforeOnairdate: '',
          DirectReceiptDate: '',
          StopOrder: '',
          ReceiptDateTicketLink: [],
          Status: 'OrderNotFinished',
          StatusName: '未発注',
          Active: true,
          Subtickets: {},
          Baseticket: {
            tableName: 'ProductionDepartmentManager',
            ticketType: 'Program',
            ticketKey: getDay(2) + '#AddToday3',
          },
        },
        {
          TableName: 'ProductionDepartmentManager',
          TicketType: 'ProgramOrder',
          TicketKey: 'ProgramOrder-1111-1111-1113',
          LsiKey: null,
          MProgramTicketKey: 'test#1111-1111-1111',
          OrderSheetTicketKey: '',
          OnairDate: getDay(2),
          OrderType: 'Master',
          MProgramOrderTicketKey: 'test#1111-1111-1111#000-0000-0001',
          Content: 'V333',
          Memo: '',
          ReceiptDate: getDay(-5),
          ReceiptDateType: '',
          CountBeforeOnairdate: '',
          DirectReceiptDate: '',
          StopOrder: '',
          ReceiptDateTicketLink: [getDay(-5) + '#1111-2222-3333'],
          Status: 'OrderFinished',
          StatusName: '発注済み',
          Active: true,
          Subtickets: {},
          Baseticket: {
            tableName: 'ProductionDepartmentManager',
            ticketType: 'Program',
            ticketKey: getDay(2) + '#AddToday3',
          },
        },
        {
          TableName: 'ProductionDepartmentManager',
          TicketType: 'ProgramOrder',
          TicketKey: 'ProgramOrder-1111-1111-1114',
          LsiKey: null,
          MProgramTicketKey: '',
          OrderSheetTicketKey: '',
          OnairDate: getDay(2),
          OrderType: 'Onetime',
          MProgramOrderTicketKey: '',
          Content: 'LLL',
          Memo: '悪魔の召喚',
          ReceiptDate: '',
          ReceiptDateType: 'Onairdate',
          CountBeforeOnairdate: '',
          DirectReceiptDate: '',
          StopOrder: '',
          ReceiptDateTicketLink: [getDay(-11) + '#1111-2222-3335'],
          Status: 'OrderNotFinished',
          StatusName: '未発注',
          Active: true,
          Subtickets: {},
          Baseticket: {
            tableName: 'ProductionDepartmentManager',
            ticketType: 'Program',
            ticketKey: getDay(2) + '#AddToday3',
          },
        },
        {
          TableName: 'ProductionDepartmentManager',
          TicketType: 'ProgramOrder',
          TicketKey: 'ProgramOrder-1111-1111-1114',
          LsiKey: null,
          MProgramTicketKey: '',
          OrderSheetTicketKey: '',
          OnairDate: getDay(2),
          OrderType: 'Onetime',
          MProgramOrderTicketKey: '',
          Content: 'TTT',
          Memo: '融合',
          ReceiptDate: getDay(-7),
          ReceiptDateType: 'BeforeOnairdate',
          CountBeforeOnairdate: 7,
          DirectReceiptDate: '',
          StopOrder: '',
          ReceiptDateTicketLink: [getDay(2) + '#1111-2222-3333'],
          Status: 'OrderFinished',
          StatusName: '発注済み',
          Active: true,
          Subtickets: {},
          Baseticket: {
            tableName: 'ProductionDepartmentManager',
            ticketType: 'Program',
            ticketKey: getDay(2) + '#AddToday3',
          },
        },
      ],
    },
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(3) + '#AddDay-1',
    EventID: 'AddDay-1',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getDay(3),
    OnairTime: '27:10:00',
    ProgramName: '光の護封剣',
    PublishTime: getDay(3) + ' 27:10:00',
    OnairDatetime: getDay(3) + ' 27:10:00',
    Status: 'OrderFinished',
    StatusName: '発注済',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(-2) + '#Yesterday-1',
    EventID: 'Yesterday-1',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-tttt',
    OnairDate: getDay(-2),
    OnairTime: '12:10:00',
    ProgramName: '時の魔術師',
    PublishTime: getDay(-2) + ' 12:10:00',
    OnairDatetime: getDay(-2) + ' 12:10:00',
    Status: 'OrderFinished',
    StatusName: '発注済',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(8) + '#OneWeekLater',
    EventID: 'OneWeekLater',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getDay(8),
    OnairTime: '16:00:00',
    ProgramName: '悪魔の召喚',
    PublishTime: getDay(8) + ' 16:00:00',
    OnairDatetime: getDay(8) + ' 16:00:00',
    Status: 'OrderFinished',
    StatusName: '発注済',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(-1) + '#Yesterday',
    EventID: 'Yesterday',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getDay(-1),
    OnairTime: '16:00:00',
    ProgramName: '青い眼を持つ白い竜',
    PublishTime: getDay(-1) + ' 16:00:00',
    OnairDatetime: getDay(-1) + ' 16:00:00',
    Status: 'OrderFinished',
    StatusName: '発注済',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(-8) + '#Yesterday',
    EventID: 'Yesterday',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-14778',
    OnairDate: getDay(-8),
    OnairTime: '16:00:00',
    ProgramName: '黒い魔術師（女）',
    PublishTime: getDay(-8) + ' 16:00:00',
    OnairDatetime: getDay(-8) + ' 16:00:00',
    Status: 'OrderFinished',
    StatusName: '未発注',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(-2) + '#Yesterday2',
    EventID: 'Yesterday2',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getDay(-2),
    OnairTime: '16:01:00',
    ProgramName: '赤い目を持つ黒い竜',
    PublishTime: getDay(-2) + ' 16:01:00',
    OnairDatetime: getDay(-2) + ' 16:01:00',
    Status: 'OrderNone',
    StatusName: '発注無',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getDay(-1) + '#Yesterday3',
    EventID: 'Yesterday3',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getDay(-1),
    OnairTime: '16:02:00',
    ProgramName: '黒い魔術師',
    PublishTime: getDay(-1) + ' 16:02:00',
    OnairDatetime: getDay(-1) + ' 16:02:00',
    Status: 'OrderNone',
    StatusName: '発注無',
    Active: true,
  },
  {
    TicketType: 'Program',
    TicketKey: getToday() + '#Today',
    EventID: 'Today',
    MProgramTicketKey: 'dadeb10e-047c-4a0e-bddb-1824eda413d5',
    OnairDate: getToday(),
    OnairTime: '12:00:00',
    ProgramName: '死者蘇生',
    PublishTime: getToday() + ' 12:00:00',
    OnairDatetime: getToday() + ' 12:00:00',
    Status: 'OrderNone',
    StatusName: '発注無',
    Active: true,
    Subtickets: {
      ProgramOrder: [
        {
          TableName: 'ProductionDepartmentManager',
          TicketType: 'ProgramOrder',
          TicketKey: 'test##########',
          LsiKey: null,
          MProgramTicketKey: '',
          OnairDate: '',
          OrderType: '',
          MProgramOrderTicketKey: '',
          Content: 'V123',
          Memo: '甦れ',
          ReceiptDate: getDay(5),
          ReceiptDateType: '',
          CountBeforeOnairdate: '',
          DirectReceiptDate: '',
          StopOrder: '',
          ReceiptDateTicketLink: [],
          Status: 'OrderNotFinished',
          StatusName: '未発注',
          Subtickets: {},
          Baseticket: {
            tableName: 'ProductionDepartmentManager',
            ticketType: 'Program',
            ticketKey: getToday() + '#Today',
          },
        },
      ],
    },
  },
];

/**
 * 現在日のフォーマットを取得
 * @returns
 */
export function getToday(): string {
  const today = new Date();
  return CastUtility.getDefaultFormatDay(today);
}

/**
 * 加算した日付を取得
 * @param addDay
 * @returns
 */
export function getDay(addDay: number): string {
  const today = new Date();
  today.setDate(today.getDate() + addDay);
  return CastUtility.getDefaultFormatDay(today);
}
